/**
 * contact form
 */
import validator from 'validator';
import axios from 'axios';

export default class Form {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'Form';
    this.isSend = false;
    this.isValidate = false;

    this.config = {
      name: {
        label: 'お名前',
        type: 'input',
        message: '',
        v: [
          'isEmpty'
        ]
      },
      mail: {
        label: 'メールアドレス',
        type: 'input',
        message: '',
        v: [
          'isEmpty',
          'isEmail'
        ]
      },
      tel: {
        label: '電話番号',
        type: 'input',
        message: '',
        v: null
      },
      message: {
        label: 'お問い合わせ内容',
        type: 'textarea',
        message: '',
        v: [
          'isEmpty'
        ]
      }
    };

    this.isError = {
      name: false,
      mail: false,
      message: false
    };

    this.isErrorMessage = {
      isEmpty: 'を入力してください',
      isEmail: '正しいメールアドレスではありません'
    };

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    // cssでnoneしている
    ///TweenMax.set(document.getElementById('form-confirm'), {display: 'none'});
    ///TweenMax.set(document.getElementById('form-complete'), {display: 'none'});
    axios
      .get('/php/contact/index.php')
      .then(response => {
        const data = response.data;
        document.getElementById('form-sosui').querySelector('input[type="hidden"][name="token"]').value = data.token;
      })
      .catch(error => {
        console.log(error);
      });

    //イベント
    var btnConfirm = document.getElementById('btn-confirm');
    btnConfirm.addEventListener('click', this.toValidate.bind(this));
    var btnSend = document.getElementById('btn-send');
    btnSend.addEventListener('click', this.toSend.bind(this));
    var btnEdit = document.getElementById('btn-edit');
    btnEdit.addEventListener('click', this.toInput.bind(this, false));
    var btnTop = document.getElementById('btn-top');
  }

  /**
   * 入力内容チェック
   */
  toValidate() {
    this.isValidate = this.validator();

    if (this.isValidate) {
      // OK：確認画面へ行く
      this.toConfirm();
    } else {
      // エラーを表示する：入力画面
      this.toInput(true);
    }
  }

  /**
   * バリデート
   */
  validator() {
    var selector = '', v = '', c = null, val = '';

    for (var i in this.config) {
      c = this.config[i];
      if (!c.v) continue;

      this.isError[i] = false;
      selector = c.type + '[name="'+ i +'"]';

      for (var j = 0; j < c.v.length; j++) {
        v = c.v[j];
        val = document.getElementById('form-input').querySelector(selector).value;

        if (v === 'isEmpty' && validator[v](val)) {
          // エラー
          this.isError[i] = true;
          c.message = c.label + this.isErrorMessage[v];
        } else if (v === 'isEmail' && !validator[v](val)) {
          // エラー
          this.isError[i] = true;
          c.message = this.isErrorMessage[v];
        }/* else if (!validator.isLength(val, {min: 1, max: 10})) {
          // エラー
        }*/
      }
    }

    //console.log(this.isError.indexOf(true), this.isError);

    if (this.checkError()) {
      // エラー：入力画面へ
      return false;
    } else {
      // OK：確認画面へ行く
      return true;
    }
  }

  checkError() {
    var isError = false;

    for (var i in this.isError) {
      if (this.isError[i]) {
        isError = true;
        break;
      }
    }

    if (isError) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 確認画面を表示する
   */
  toConfirm() {
    var selector1= '', selector2 = '';
    for (var i in this.config) {

      selector1 = document.getElementById('form-input').querySelector(this.config[i].type + '[name="'+ i +'"]');
      selector2 = document.getElementById('form-confirm').querySelector('.is-confirm--' + i);

      selector2.textContent = validator.escape(selector1.value);
    }

    TweenMax.to(document.getElementById('form-input'), 0.6,{
      display: 'none',
      opacity: 0,
      ease: Cubic.easeOut,
      onComplete: this.toConfirmComp.bind(this)
    });

    TweenMax.to(window, 0.6, {scrollTo:{y: 0, autoKill: false}});
  }

  toConfirmComp() {
    TweenMax.fromTo(document.getElementById('form-confirm'), 0.6, {
        display: 'block',
        opacity: 0
      }, {
        opacity: 1,
        ease: Cubic.easeOut,
      }
    );
  }

  /**
   * 入力フォームに戻る（エラー表示）
   */
  toInput(isError, e) {
    var isDisplay = 'none';
    if (isError) {
      isDisplay = 'block';
    }

    var selector1= '';
    for (var i in this.isError) {
      selector1 = document.getElementById('form-input').querySelector('.is-err--' + i);
      if (this.isError[i]) {
        TweenMax.set(selector1, {display: isDisplay});
        selector1.textContent = this.config[i].message;
      } else {
        TweenMax.set(selector1, {display: 'none'});
        selector1.textContent = '';
      }
    }

    if (!isError) {
      TweenMax.to(document.getElementById('form-confirm'), 0.6,{
        display: 'none',
        opacity: 0,
        ease: Cubic.easeOut,
        onComplete: this.toInputComp.bind(this)
      });
    }

    TweenMax.to(window, 0.6, {scrollTo:{y: 0, autoKill: false}});
  }

  toInputComp(isError) {
    TweenMax.fromTo(document.getElementById('form-input'), 0.6, {
        display: 'block',
        opacity: 0
      }, {
        opacity: 1,
        ease: Cubic.easeOut,
      }
    );
  }
  /**
   * 送信する
   */
  toSend(e) {
    e.preventDefault();

    if (!this.isSend) {
      this.isSend = true;

      let selector1 = '';
      let selector2 = new URLSearchParams();

      for (let i in this.config) {
        selector1 = document.getElementById('form-input').querySelector(this.config[i].type + '[name="'+ i +'"]');
        selector2.append('your-'+ i, validator.escape(selector1.value));
      }
      selector2.append('token', document.getElementById('form-sosui').querySelector('input[name="token"]').value);
      selector2.append('state', 'complete');

      axios
        .post('/php/contact/index.php', selector2)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });

      TweenMax.to(document.getElementById('form-confirm'), 0.6,{
        display: 'none',
        opacity: 0,
        ease: Cubic.easeOut,
        onComplete: this.toComplete.bind(this)
      });

      TweenMax.to(window, 0.6, {scrollTo:{y: 0, autoKill: false}});
    }
  }

  /**
   * 完了画面を表示する
   */
  toComplete() {
    TweenMax.fromTo(document.getElementById('form-complete'), 0.6, {
        display: 'block',
        opacity: 0
      }, {
        opacity: 1,
        ease: Cubic.easeOut,
      }
    );
  }
}